export enum UserType {
  User = 1,
  ChannelPartner = 2
}
